// frontend/src/utils/surgicalHistoryProcedures.js

const surgicalHistoryProcedures = {
  general: [
      'No history of surgery'
  ],
  neuro_ent_eye: [ // TK, Tai Mũi Họng, Mắt
    'Brain',
    'Eye',
    'Nose'
  ],
  cardiac_thoracic: [ // Tim Mạch - Lồng Ngực
    'Cardiac catheterization',
    'Heart valve (replacement - repair)',
    'Heart transplant',
    'Implantation of a pacemaker or defibrillator',
    'Lung',
    'Lung transplant'
  ],
  gi_hepatobiliary: [ // Tiêu Hóa - Gan Mật
    'Stomach',
    'Intestines', // (Consider more specific options like Appendectomy, Colectomy if needed)
    'Liver',
    'Liver transplant',
    'Gallbladder' // (e.g., Cholecystectomy)
  ],
  renal_urology: [ // Thận - Tiết Niệu
    'Kidney',
    'Kidney transplant',
    'Bladder',
    'Prostate gland' // (e.g., TURP)
  ],
  orthopedic: [ // Cơ Xương Khớp
    'Hip joint', // (e.g., Hip replacement)
    'Knee joint',  // (e.g., Knee replacement)
    'Lumbar spine' // (e.g., Laminectomy, Fusion)
  ],
  gynecology_breast: [ // Phụ Khoa - Vú
    'Ovary', // (e.g., Oophorectomy)
    'Uterus', // (e.g., Hysterectomy)
    'Mammary gland' // (e.g., Mastectomy, Lumpectomy)
  ],
  // Removed 'oncologyRelated' as items are categorized now.
  // Keep 'other' for manual entries or less common procedures.
  other: [
  ]
};

export default surgicalHistoryProcedures;
